/* Next10 - adiciona ao carrinho via AJAX e abre o minicart lateral.
   Vale para: cards da vitrine (.n10-card__form), barra de compra da PDP (.pdp-bar__form)
   e qualquer formulario marcado com data-n10-cart-form. */
(function () {
  if (window.__n10CartAjax) return;
  window.__n10CartAjax = true;

  var SELECTOR = '.n10-card__form, .pdp-bar__form, [data-n10-cart-form]';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getDrawer() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }

  function refreshBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch(ROOT + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('cart-icon-bubble');
        if (next) bubble.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  function getButton(form) {
    return form.querySelector('.n10-card__btn, .pdp-bar__btn, button[type="submit"]');
  }

  function restore(btn, label, text) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.disabled = false;
    if (!text) { btn.textContent = label; return; }
    btn.textContent = text;
    setTimeout(function () { btn.textContent = label; }, 1800);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form) return;

    /* Em cards com varias variantes o id vem do radio marcado, nao do primeiro input. */
    var idInput = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    e.preventDefault();

    var btn = getButton(form);
    var label = btn ? btn.textContent.trim() : '';
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.textContent = 'Adicionando...';
    }

    var drawer = getDrawer();
    var payload = { items: [{ id: idInput.value, quantity: qty }] };
    if (drawer) {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          restore(btn, label, 'Indisponível');
          return;
        }

        restore(btn, label, 'Adicionado!');

        if (drawer && data && data.sections) {
          drawer.renderContents(data);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          refreshBubble();
        } else {
          refreshBubble();
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'n10-cart-ajax',
            productVariantId: idInput.value
          });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        restore(btn, label);
      });
  });
})();
